import { Box, Button, Typography } from '@mui/material';
import { FC } from 'react';
import { FlexRowCenter } from '../../../components/LayoutBoxes';
import { SessionDiscardData } from '../../../stores/dialogStore';
import { dialogStyles as styles } from '../styles/dialogStyles';
import { BaseDialog } from './BaseDialog';

interface SessionDiscardDialogProps {
  data?: SessionDiscardData;
  onConfirm: () => void;
  onContinue?: () => void;
  onCancel: () => void;
}

export const SessionDiscardDialog: FC<SessionDiscardDialogProps> = ({
  data,
  onConfirm,
  onContinue,
  onCancel,
}) => {
  const hasTranscript = data?.hasTranscript || false;
  const hasDocument = data?.hasDocument || false;
  const canContinue = data?.canContinue === true;

  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onCancel();
  };

  return (
    <BaseDialog open={true} onClose={handleCancel} showCloseButton={false}>
      <Box sx={styles.discardContainer}>
        <Typography
          variant='dialogTitle'
          component='h2'
          sx={styles.discardTitle}
        >
          Start New Session?
        </Typography>

        <Typography
          variant='dialogBody'
          component='p'
          sx={styles.discardSubtitle}
        >
          {canContinue
            ? 'Continue the current transcript or discard it and capture a new one?'
            : 'Are you sure you want to discard the previous session and capture a new one?'}
        </Typography>

        {(hasTranscript || hasDocument) && (
          <Typography variant='body2' sx={styles.discardWarningText}>
            This will discard:
            {hasTranscript && ' your transcript'}
            {hasTranscript && hasDocument && ' and'}
            {hasDocument && ' your generated document'}
          </Typography>
        )}

        <FlexRowCenter sx={styles.discardButtonContainer}>
          <Button
            variant='outlined'
            onClick={handleCancel}
            size='small'
            sx={styles.discardCancelButton}
          >
            Cancel
          </Button>
          {canContinue && (
            <Button
              variant='outlined'
              onClick={onConfirm}
              size='small'
              sx={styles.discardConfirmButton}
            >
              Discard &amp; Start New
            </Button>
          )}
          <Button
            variant='contained'
            onClick={canContinue ? onContinue : handleConfirm}
            size='small'
            sx={styles.discardConfirmButton}
          >
            {canContinue ? 'Continue Transcript' : 'Discard & Record'}
          </Button>
        </FlexRowCenter>
      </Box>
    </BaseDialog>
  );
};
